import APIService from "./APIService";

const SmsConsentAPI = {
  /**
   * Create a new SMS consent record
   * @param {Object} data - SMS consent data to create
   * @returns {Promise} - Promise that resolves with the created consent record
   */
  createSmsConsent: async (data) => {
    return APIService.post("/api/v1/base/sms-consent", data);
  },

  /**
   * Opt in to SMS notifications (for authenticated users)
   * @param {string} userUuid - User UUID
   * @returns {Promise} - Promise that resolves with opt-in result
   */
  optInSmsConsent: async (userUuid) => {
    return APIService.post("/api/v1/base/sms-consent/opt-in", {
      userUuid,
    });
  },

  /**
   * Get SMS consent by phone number
   * @param {string} phoneNumber - Phone number to look up
   * @returns {Promise} - Promise that resolves with the consent record
   */
  getSmsConsentByPhone: async (phoneNumber) => {
    return APIService.get(
      `/api/v1/base/sms-consent/status?phoneNumber=${encodeURIComponent(
        phoneNumber
      )}`
    );
  },

  /**
   * Verify SMS consent using phone number and verification code
   * @param {string} phoneNumber - Phone number to verify
   * @param {string} verificationCode - Verification code
   * @param {string} userUuid - User UUID
   * @returns {Promise} - Promise that resolves with verification result
   */
  verifySmsConsent: async (phoneNumber, verificationCode, userUuid) => {
    return APIService.post("/api/v1/base/sms-consent/verify", {
      phoneNumber,
      verificationCode,
      userUuid,
    });
  },

  /**
   * Opt out from SMS communications
   * @param {string} phoneNumber - Phone number to opt out
   * @returns {Promise} - Promise that resolves with opt-out result
   */
  optOutSmsConsent: async (phoneNumber) => {
    return APIService.post("/api/v1/base/sms-consent/opt-out", {
      phoneNumber,
    });
  },
};

// Named export for convenience
export const submitSmsConsent = SmsConsentAPI.createSmsConsent;

export default SmsConsentAPI;
